import { navLinks } from "@/mocks/home";

export default function SiteFooter() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-secondary-950 pt-14 pb-8">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr]">
          <div>
            <div className="flex items-center gap-2 font-heading text-lg font-semibold text-background-50">
              <i className="ri-film-line text-xl text-accent-400"></i>
              善良的小姨子在线
            </div>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-secondary-200">
              本站是一个围绕主题展开的信息整理页面，主要说明在线观看、在线播放、高清在线、免费在线以及完整版与无删减之间的差别，帮助你在浏览前先建立清晰的预期。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div>
              <h3 className="font-label text-sm font-semibold text-background-50">快速导航</h3>
              <ul className="mt-4 space-y-2">
                {navLinks.slice(0, 4).map((link) => (
                  <li key={link.id}>
                    <button
                      type="button"
                      onClick={() => jump(link.id)}
                      className="text-sm text-secondary-200 transition-colors hover:text-accent-300 cursor-pointer"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-label text-sm font-semibold text-background-50">更多</h3>
              <ul className="mt-4 space-y-2">
                {navLinks.slice(4).map((link) => (
                  <li key={link.id}>
                    <button
                      type="button"
                      onClick={() => jump(link.id)}
                      className="text-sm text-secondary-200 transition-colors hover:text-accent-300 cursor-pointer"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 善良的小姨子在线 · 本页内容仅作信息整理与浏览说明。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span className="whitespace-nowrap">请合理安排观看时间</span>
            <span className="whitespace-nowrap">尊重版权，通过正规渠道获取内容</span>
          </p>
        </div>
      </div>
    </footer>
  );
}